import { memo, useCallback } from "react";
import { FleetVehicleDamageEditFormValues } from "services/api/fleet/vehicles/damages/types";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";
import FileUploadControl from "ui/components/FileUpload/FileUploadControl/FileUploadControl";

interface DamageDocumentFormProps {
  formValues: FleetVehicleDamageEditFormValues;
  setFormValues: React.Dispatch<
    React.SetStateAction<FleetVehicleDamageEditFormValues>
  >;
}

const DamageDocumentForm: React.FC<DamageDocumentFormProps> = ({
  formValues,
  setFormValues,
}) => {
  const handleDocumentUploadSave = useCallback(
    (uploads: FleetDocumentUpload[]) => {
      setFormValues((prev) => ({
        ...prev,
        documentUploads: [...prev.documentUploads, ...uploads],
      }));
    },
    []
  );

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm font-medium text-gray-700">
          Dokumentacija
        </label>
      </div>

      <FileUploadControl
        uploads={formValues.documentUploads}
        onUploadSave={handleDocumentUploadSave}
        onUploadDelete={(id) => setFormValues(prev => ({...prev, documentUploads: prev.documentUploads.filter(u => u.id !== id)}))}
        buttonText="Dodaj dokumente"
        modalTitle="Upload dokumenta"
        emptyText="Dodajte dokumente vezane uz štetu"
      />
    </div>
  );
};

export default memo(DamageDocumentForm);
